import type { Guide, GuideRecordHint } from '../types';

/**
 * S-25.10-03 — zgoda Team Leadera działu na zmianę zlecenia po wyjeździe na załadunek (scenariusz e2e 32;
 * model rekordu zlecenia §6.2 pkt 5, przejście P16). Rekord: DEMO/2026/10/Q01 — okno załadunku trwa,
 * zgłoszona zmiana wagi czeka na Administrację (`scenario-state.mjs`). CS i Administracja nie mają liderów
 * (decyzja użytkownika 26.10.2026) — zgodę ich strony daje każdy z działu.
 */
const DEPARTED: GuideRecordHint = {
  description: 'zlecenie z TMS po wyjeździe auta na załadunek, ze zgłoszoną zmianą, która czeka na decyzję',
  listPath: '/order-changes',
  listFilter: { status: 'pending' },
};

export const guide: Guide = {
  flagKey: 'orderChangeLeadAfterDeparture',
  title: 'Zgoda Team Leadera działu na zmianę zlecenia po wyjeździe na załadunek',
  whatItDoes:
    'Gdy pojazd wyruszył już na załadunek, zmianę danych zlecenia („było → ma być”) zatwierdza dział, do którego należy pole. CS i Administracja nie mają liderów, więc po ich stronie zgodę daje każdy z działu; po stronie Trade — Team Leader Trade, a po stronie floty — planista główny. Wyjazd liczymy tak samo jak przy odpięciu auta: status w TMS, trwające okno załadunku albo szacunek z dolotu. Zmiana czeka na decyzję — nic nie dzieje się samo. Gdy w systemie nie ma konta, które może się zgodzić, decyduje administrator. W historii zlecenia zostaje wpis, że zmiana przyszła po wyjeździe i kto się zgodził.',
  audience: ['CS', 'Administracja', 'Team Leader Trade', 'planista główny'],
  presentationItems: ['S-25.10-03'],
  steps: [
    {
      route: '/user-offers/:orderId/show',
      record: DEPARTED,
      target: 'order-change-lead-approval',
      title: 'Po wyjeździe — kto zatwierdza',
      description:
        'Przy zmianie zgłoszonej po wyjeździe auta na załadunek stoi informacja, na kogo czeka i skąd wiemy o wyjeździe: w CS i Administracji — na każdego z działu, w Trade — na Team Leadera Trade, we flocie — na planistę głównego. Kto nie może się zgodzić, nie ma przycisku „Akceptuj”.',
      action: 'Otwórz kartę zlecenia i znajdź sekcję „Zmiany zlecenia (było → ma być)”.',
      recorder: { account: 'adm', demo: { kind: 'order', number: 'DEMO/2026/10/Q01' } },
    },
    {
      route: '/user-offers/:orderId/show',
      record: DEPARTED,
      target: 'order-change-accept',
      title: 'Dział akceptuje',
      description:
        'Dział, do którego należy pole (tu waga — Administracja), akceptuje albo odrzuca zmianę z powodem. Wpis w historii zlecenia mówi, że zgoda zapadła po wyjeździe, i przytacza ocenę wyjazdu. Dalej jak dotąd: zmianę wpisuje się w TMS, a import ją zamyka.',
      action: 'Jako Administracja kliknij „Akceptuj” przy zmianie i wpisz powód decyzji.',
      recorder: { account: 'adm', demo: { kind: 'order', number: 'DEMO/2026/10/Q01' } },
    },
    {
      route: '/order-changes',
      target: 'order-change-list',
      title: 'Lista „Zmiany zleceń”',
      description:
        'Na liście „Zmiany zleceń” zmiana po wyjeździe ma tę samą informację — widać, na czyją decyzję czeka.',
      action: 'Otwórz „Zmiany zleceń” w menu.',
      recorder: { account: 'adm' },
    },
  ],
};
